import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import useIsDesktopLayout from '@hooks/useIsDesktopLayout';

import CartItem from '../../components/CartItem';
import LeftComponent from '../../components/CartItem/components/LeftComponent';

const onDelete = (item, onItemChecked) => () => onItemChecked(item);

const onSelect = (item, onItemClicked) => () => onItemClicked(item);

const Container = styled.div`
  ${({ withScroll }) =>
    withScroll &&
    css`
      max-height: 420px;
      overflow: auto;
    `}
`;

function CartList({
  items,
  isEditing,
  itemsSelected,
  onItemChecked,
  onItemClicked,
  cartItemsRequireValidate,
  isUpdatingLines,
}) {
  const isDesktopLayout = useIsDesktopLayout();
  if (items.length === 0) return null;

  return (
    <Container withScroll={isDesktopLayout}>
      {items.map((item, index) => (
        <CartItem
          key={item.guid}
          guid={item.guid}
          name={item.name}
          options={item.optionGroups}
          subtotal={item.subtotal}
          subtotalNoDiscount={item.subtotalNoDiscount}
          quantity={item.quantity}
          maxQuantity={item?.maxQuantity}
          productId={item.product}
          leftComponent={<LeftComponent item={item} />}
          isEditing={isEditing}
          isSelected={itemsSelected.includes(item.guid)}
          onDelete={onDelete(item, onItemChecked)}
          onSelect={onSelect(item, onItemClicked)}
          subsidizedProduct={item.subsidizedProduct}
          requireValidation={cartItemsRequireValidate?.includes(item.product)}
          cartItems={items}
          isUpdatingLines={isUpdatingLines}
          desktop={isDesktopLayout}
          item={item}
          onClick={onSelect(item, onItemClicked)}
          position={index}
        />
      ))}
    </Container>
  );
}

CartList.propTypes = {
  items: PropTypes.array.isRequired,
  isEditing: PropTypes.bool.isRequired,
  itemsSelected: PropTypes.array.isRequired,
  onItemChecked: PropTypes.func.isRequired,
  onItemClicked: PropTypes.func.isRequired,
  cartItemsRequireValidate: PropTypes.array,
  isUpdatingLines: PropTypes.bool,
};

export default React.memo(CartList);
